var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AuthContainer',{attrs:{"title":_vm.$t('auth.two-factor-code')}},[_c('TwoFactorForm'),_c('router-link',{staticClass:"back-to-login",attrs:{"to":"/login"}},[_vm._v(" "+_vm._s(_vm.$t("auth.back-to-login-cta"))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }